<template>
  <PlatDataPanelSelect class="teaching-arrange-schedule"
                       :custom-id="customId"
                       :data-types="['semester', 'site']"
                       semesterLabel="选择排课学期"
                       siteLabel="选择教学点">
    <template #default="scope">
      <keep-alive>
        <TeachingArrangeScheduleMain :key="`${scope.semester}:${scope.site}`"
                                     v-bind="scope"></TeachingArrangeScheduleMain>
      </keep-alive>
    </template>
  </PlatDataPanelSelect>
</template>

<script>
import PlatDataPanelSelect from '../../../wrapper/panel/PlatDataPanelSelect'
import TeachingArrangeScheduleMain from './main'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'TeachingArrangeSchedule',
  components: {
    PlatDataPanelSelect,
    TeachingArrangeScheduleMain
  },
  data () {
    return {
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>

<style lang="scss">
  .teaching-arrange-schedule {
    height: 100%;
  }
</style>
